import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import ComponentScrollbar from "../../../BaseComponents/ComponentScrollbar";
import Image, { ICONS } from "../../../BaseComponents/Image";
import Typography from "../../../BaseComponents/Typography";

import { DIGIPOSTHEME } from "theme/digiPosTheme";

import {
  StyledOuterContainer,
  StyledInnerContainer,
} from "./InformationImageList.styles";

const InformationImageList: FC = () => {
  const { t } = useTranslation();
  return (
    <ComponentScrollbar>
      <StyledOuterContainer>
        {/* <StyledInnerContainer>
          <Image
            alt='Button Logo'
            height='65px'
            margin='-5px 5px 0 0'
            srcSet={ICONS.CALCULATE}
            width='64px'
          />

          <Typography
            align='center'
            color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
            letterSpacing='0.23px'
            size='16px'
            transform='none'
            variant='span'
            weight='500'
            height='57px'
          >
            {t("login_manuelpos_card_title")}
          </Typography>
        </StyledInnerContainer> */}

        <StyledInnerContainer margin='0 0 0 16px'>
          <Image
            alt='Button Logo'
            height='65px'
            margin='-5px 5px 0 0'
            srcSet={ICONS.HUMAN}
            width='64px'
          />

          <Typography
            align='center'
            color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
            letterSpacing='0.23px'
            size='16px'
            transform='none'
            variant='span'
            weight='500'
            height='57px'
          >
            {t("login_user_card_title")}
          </Typography>
        </StyledInnerContainer>

        <StyledInnerContainer margin='0 0 0 16px'>
          <Image
            alt='Button Logo'
            height='65px'
            margin='-5px 5px 0 0'
            srcSet={ICONS.BILL_CARD}
            width='64px'
          />

          <Typography
            align='center'
            color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
            letterSpacing='0.23px'
            size='16px'
            transform='none'
            variant='span'
            weight='500'
            height='57px'
          >
            {t("login_cebepos_card_title")}
          </Typography>
        </StyledInnerContainer>
      </StyledOuterContainer>
    </ComponentScrollbar>
  );
};

export default InformationImageList;
